export const OPERATION_TYPES = [
    { value: 'bump_test', label: 'Bump Test' },
    { value: 'calibration', label: 'Calibration' },
];

export const GAS_READINGS = [
    { key: 'h2sResult', label: 'H₂S' },
    { key: 'coResult', label: 'CO' },
    { key: 'o2Result', label: 'O₂' },
    { key: 'lelResult', label: '%LEL' },
];

// Bump Test: все Gas Monitor + Sniffer
export const TOOL_TYPE_FILTERS = ['Gas Monitor', 'Sniffer'];

// Calibration: только Type=Gas Monitor AND Description=Gas Monitor
export const CALIBRATION_TOOL_FILTER = { type: 'Gas Monitor', description: 'Gas Monitor' };

export const STATUS_DRAFT = 'draft';
export const STATUS_SUBMITTED = 'submitted';
